export const isCommentUnpublished = (value: boolean | undefined) => {
    return value != undefined && !value;
}

export const isCommentPublished = (value: boolean | undefined) => {
    return value === undefined || value;
}
